function getUserAgent() {
  return window.navigator.userAgent.toLowerCase();
}

export const isSDKLite = () => new RegExp('w*( VCO_SDK)w*').test(window.navigator.userAgent);

// US57100
// https://bugs.chromium.org/p/chromium/issues/detail?id=760780
export function isChromeOnIOS() {
  const ua = getUserAgent();
  return /iphone|ipod|ipad/i.test(ua) && /CriOS/i.test(ua);
}

export function isAndroidMobile() {
  const ua = getUserAgent();
  return ua.includes('android') && ua.includes('mozilla/5.0') && ua.includes('applewebkit');
}

function isAndroidWebview() {
  // https://developer.chrome.com/multidevice/user-agent#webview_user_agent
  return /wv/i.test(getUserAgent());
}

export function isIOSAndroid() {
  const ua = getUserAgent();
  return /iPad|iPhone|iPod|Android/.test(ua) && !window.MSStream;
}

function isIOSWebView() {
  const userAgent = getUserAgent();
  const safari = /safari/i.test(userAgent);
  const iOS = /iphone|ipod|ipad/i.test(userAgent);
  return iOS && !safari;
}

export function isPhoneBrowser() {
  return /Mobile/i.test(window.navigator.userAgent);
}

export function isMobileSafari() {
  const ua = getUserAgent();
  return (
    // iOS
    /iphone|ipod|ipad/i.test(ua) &&
    // webkit
    /WebKit/i.test(ua) &&
    // not chrome for iOS
    !/CriOS/i.test(ua)
  );
}

export function isHybridImplementation() {
  const userAgent = getUserAgent();
  const isVisaSDKLite = userAgent.indexOf('vco_sdk') !== -1;
  const isVisaHybridSDKLite = userAgent.indexOf('vco_hsdk') !== -1;

  return isVisaSDKLite || isVisaHybridSDKLite || isIOSWebView() || isAndroidWebview();
}

export function isSafari() {
  const ua = getUserAgent();
  return /^((?!chrome|android).)*safari/i.test(ua);
}

export function isPopupBrowser(isIntegrated: boolean) {
  if (isIntegrated) {
    return false;
  }

  return isMobileSafari() || isChromeOnIOS() || isSafari() || isHybridImplementation();
}

export function getAppInstance() {
  const isMobileSdk = isHybridImplementation();

  if (isMobileSdk) {
    return 'MobileSdk';
  }

  if (isMobileSafari() || isChromeOnIOS() || isIOSAndroid() || isAndroidMobile()) {
    return 'MobileWeb';
  }

  return 'Web';
}

/* istanbul ignore next */
export function getPlatformType() {
  if (isAndroidWebview()) {
    return 'ANDROID';
  }

  if (isIOSWebView()) {
    return 'iOS';
  }

  if (/windows phone/i.test(navigator.userAgent)) {
    return 'WINDOWS';
  }

  return 'WEB';
}
